<template>
    <div v-if="data" class="data-display-in-block">
        <div class="data-title-container">
            <div class="data-title">
                <h3>{{label}}</h3>
            </div>
            <ExtraInfo :inBlock="true" :id="infoKey"></ExtraInfo>
        </div>
        <div class="data-content data-clean text-content">
            <div v-html="data"></div>
        </div>
    </div>
</template>
<script>
import ExtraInfo from "./ExtraInfo";
export default {
    name: "DataDisplayInBlock",
    components: {
        ExtraInfo
	},
	props: {
		data: String,
        label: String,
        infoKey: String
	}
};
</script>
<style lang="less" scoped>
    .data-display-in-block {
        display: flex;
        flex-direction: column;
    }

    .data-title {
        float:left;
    }

    .data-content div {
		color: #25167A;
	}
</style>